import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import type {} from '@mui/material/themeCssVarsAugmentation';
import React, { useContext } from 'react';

import { ThemeContext } from './context';
import {
  colorSchemes,
  customShadows,
  defaultFont,
  shadows,
  typography,
} from './core';
import { components } from './core/components';
import { setFont } from './styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function CustomThemeProvider({ children }: Props) {
  const { themeMode } = useContext(ThemeContext);

  const theme = createTheme({
    palette: colorSchemes[themeMode].palette,
    shadows: shadows(themeMode),
    customShadows: customShadows(themeMode),
    direction: 'ltr',
    shape: { borderRadius: 8 },
    components,
    typography: {
      ...typography,
      fontFamily: setFont(defaultFont),
    },
  });

  return (
    <ThemeProvider theme={theme} defaultMode={themeMode}>
      <CssBaseline enableColorScheme />
      <style>
        {`
          :root {
          background-color: ${theme.palette.background.default};
        }
        `}
      </style>
      {children}
    </ThemeProvider>
  );
}
